import { useState } from 'react';
import RecruiterLayout from '@/components/RecruiterLayout';
import { PerformanceFilters } from '@/components/performance/PerformanceFilters';
import { RecruiterOverview } from '@/components/performance/RecruiterOverview';
import { RecruiterMetricsCards } from '@/components/performance/RecruiterMetricsCards';
import { FunnelVisualization } from '@/components/performance/FunnelVisualization';
import { PerformanceComparison } from '@/components/performance/PerformanceComparison';
import { ExportButton } from '@/components/performance/ExportButton';
import { usePerformanceData } from '@/hooks/usePerformanceData';
import { Loader2 } from 'lucide-react';

const PerformanceDashboard = () => {
  const [selectedRecruiterId, setSelectedRecruiterId] = useState<string | null>(null);
  const [dateRange, setDateRange] = useState<{ from: Date | null; to: Date | null }>({
    from: new Date(new Date().setDate(new Date().getDate() - 30)),
    to: new Date(),
  });

  const { data, isLoading, recruiters } = usePerformanceData(dateRange, selectedRecruiterId);

  return (
    <RecruiterLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-3xl font-bold">Performance Dashboard</h1>
            <p className="text-muted-foreground">
              Track recruiter performance and team productivity
            </p>
          </div>
          <ExportButton data={data} dateRange={dateRange} />
        </div>

        {/* Filters */}
        <PerformanceFilters
          recruiters={recruiters}
          selectedRecruiterId={selectedRecruiterId}
          onRecruiterChange={setSelectedRecruiterId}
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />

        {isLoading ? (
          <div className="flex items-center justify-center h-64">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <>
            {/* Overview Cards */}
            <RecruiterMetricsCards data={data} selectedRecruiterId={selectedRecruiterId} />

            {/* Recruiter List / Overview */}
            <RecruiterOverview 
              data={data} 
              selectedRecruiterId={selectedRecruiterId}
              onSelectRecruiter={setSelectedRecruiterId}
            />

            {/* Funnel Visualization */}
            <FunnelVisualization data={data} selectedRecruiterId={selectedRecruiterId} />

            {/* Performance Comparison */}
            <PerformanceComparison data={data} />
          </>
        )}
      </div>
    </RecruiterLayout>
  );
};

export default PerformanceDashboard;
